import React from "react";
import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";

const processOptions = (options) =>
  options.map(({ id, attributes }) => ({
    value: id,
    label: attributes.name,
  }));

function CompanySelect(props) {
  return (
    <RemoteSelect url="companies" processOptions={processOptions} {...props} />
  );
}

export default CompanySelect;
